import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {TransactionWrapper} from '../../../model/transactionWrapper';
import {Constants} from '../../../constants/ebtq-constants';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {UtilityService} from '../../../services/utility-service';
import {Title} from '@angular/platform-browser';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-query-transactions-delete',
  templateUrl: './query-transactions-delete.component.html',
  styleUrls: ['./query-transactions-delete.component.scss']
})
export class QueryTransactionsDeleteComponent implements OnInit {

  selectedTransactionsList: any[];
  transactionWrapper: TransactionWrapper;
  cols: any[];
  containsError = false;
  errorMsg: string;
  deleteFlag = false;
  title = 'Delete Loan Confirmation';

  constructor(private apiService: ApiService, private router: Router, private location: Location,
              private utilityService: UtilityService, private route: ActivatedRoute, private titleService: Title,
              private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.selectedTransactionsList = this.apiService.getTransactionList();

    this.cols = [
      {field: 'tranSysKey', header: 'Transaction ID'},
      {field: 'loanNumber', header: 'Loan Number'},
      {field: 'actionCode', header: 'Action Code'},
      {field: 'transactionAmt', header: 'Transaction Amount'}

    ];
  }



  cancelButton() {
    this.location.back();
  }

  confirmDelete() {
    const transIdList = [];

    this.selectedTransactionsList.forEach(transactionData=>{
      transIdList.push(transactionData.tranSysKey);
    });

    this.transactionWrapper = new TransactionWrapper();
    this.transactionWrapper.queryServiceName = Constants.DELETE_TRANSACTIONS;
    this.transactionWrapper.parameters[0] = transIdList;

    this.apiService.executeQuery(this.transactionWrapper).subscribe(data=>{
      console.log('data', data);
      this.deleteFlag = true;
      this.cdr.detectChanges();
    },
    error=>{
      console.log(error);
    });
  }
}
